import { useMemo } from "react";
import { i18n } from "app/i18n/i18n";
import { useProdCopyUrl } from "components/PreferencesDialog/redesignUtils";
import { useFetch } from "lib/useFetch";
import { useGetPreferences } from "api/preferences/useGetPreferences";
import { PUB_LANG } from "redux/slices/api/initialisePreferences";

const MIN_DOC_COUNT = 3;
const ONE_WEEKS_IN_DAYS = 7;

const buildRequestBody = (langs) => {
  const now = new Date();
  const oneWeekAgo = new Date(now);
  oneWeekAgo.setDate(oneWeekAgo.getDate() - ONE_WEEKS_IN_DAYS);
 // {gte: "2026-07-06T18:30:00.000Z"} 
  return {
    query: {
      bool: {
        must: [
          {
            bool: {
              should: langs.map((lang) => ({ term: { language: lang } })),
            },
          }
         ,{
            range: {
              publicationDate: {
                gte: oneWeekAgo,
              },
            },
          }
         ,{
            range: {
              publicationDate: {
                lte: now,
              },
            },
          },
        ],
      },
    },
    aggs: {
      "themes.en": {
        terms: { field: "themes.en" },
      },
      "themes.ja": {
        terms: { field: "themes.ja" },
      },
    },
    sort: {
      publicationDate: { order: "desc" },
    },
    _source: ["id", "title", "publicationDate", "themes"],
    from: 0,
    size: 0,
  };
};

const jsApiUrl = (prodCopyUrl) => `/research/${prodCopyUrl}/pub/search/query`;

export function useGetThemeInFocus() {
  const prodCopyUrl = useProdCopyUrl();
  const lang = i18n.getLanguage();
  const pubLangPref = useGetPreferences(PUB_LANG);
  const body = useMemo(() => JSON.stringify(buildRequestBody(pubLangPref)), [pubLangPref]);
  const [data, isLoading, isError] = useFetch(jsApiUrl(prodCopyUrl), body, "POST");

  const themes = parseThemeAggregations(data, lang);
  return { themes, isLoading, isError };
}

function parseThemeAggregations(data, lang) {
  try {
    const aggKey = `themes.${lang}`;
    const buckets = data?.aggregations?.[aggKey]?.buckets || [];
    return buckets
      .filter((bucket) => bucket.doc_count >= MIN_DOC_COUNT)
      .map((bucket) => bucket.key);
  } catch {
    return [];
  }
}
